﻿package org.zq.pixelset.model

data class SavedAppSettings(
    val targetWidth: Int = 800,
    val targetHeight: Int = 600,
    val lockAspectRatio: Boolean = true,
    val selectedPresetIndex: Int = 2,
    val outputFormat: String = OutputFormat.JPG.name,
    val quality: Float = 0.85f,
    val scaleMode: String = ScaleMode.Fit.name,
    val processingMode: String = ProcessingMode.Resize.name,
    val autoPreviewEnabled: Boolean = false,
    val rotationDegrees: Int = 0,
    val cropLeft: Float = 0f,
    val cropTop: Float = 0f,
    val cropRight: Float = 0f,
    val cropBottom: Float = 0f,
    val brightness: Int = 0,
    val contrast: Float = 1f,
    val saturation: Float = 1f,
) {
    fun encode(): String = buildString {
        appendLine("targetWidth=$targetWidth")
        appendLine("targetHeight=$targetHeight")
        appendLine("lockAspectRatio=$lockAspectRatio")
        appendLine("selectedPresetIndex=$selectedPresetIndex")
        appendLine("outputFormat=$outputFormat")
        appendLine("quality=$quality")
        appendLine("scaleMode=$scaleMode")
        appendLine("processingMode=$processingMode")
        appendLine("autoPreviewEnabled=$autoPreviewEnabled")
        appendLine("rotationDegrees=$rotationDegrees")
        appendLine("cropLeft=$cropLeft")
        appendLine("cropTop=$cropTop")
        appendLine("cropRight=$cropRight")
        appendLine("cropBottom=$cropBottom")
        appendLine("brightness=$brightness")
        appendLine("contrast=$contrast")
        appendLine("saturation=$saturation")
    }

    companion object {
        fun decode(raw: String?): SavedAppSettings? {
            if (raw.isNullOrBlank()) return null
            val map = raw.lineSequence()
                .map { it.trim() }
                .filter { it.contains('=') }
                .mapNotNull { line ->
                    val idx = line.indexOf('=')
                    if (idx <= 0) null else line.substring(0, idx) to line.substring(idx + 1)
                }
                .toMap()
            if (map.isEmpty()) return null
            return SavedAppSettings(
                targetWidth = map.int("targetWidth", 800),
                targetHeight = map.int("targetHeight", 600),
                lockAspectRatio = map.bool("lockAspectRatio", true),
                selectedPresetIndex = map.int("selectedPresetIndex", 2),
                outputFormat = map["outputFormat"] ?: OutputFormat.JPG.name,
                quality = map.float("quality", 0.85f),
                scaleMode = map["scaleMode"] ?: ScaleMode.Fit.name,
                processingMode = map["processingMode"] ?: ProcessingMode.Resize.name,
                autoPreviewEnabled = map.bool("autoPreviewEnabled", false),
                rotationDegrees = map.int("rotationDegrees", 0),
                cropLeft = map.float("cropLeft", 0f),
                cropTop = map.float("cropTop", 0f),
                cropRight = map.float("cropRight", 0f),
                cropBottom = map.float("cropBottom", 0f),
                brightness = map.int("brightness", 0),
                contrast = map.float("contrast", 1f),
                saturation = map.float("saturation", 1f),
            )
        }

        private fun Map<String, String>.int(key: String, default: Int): Int =
            this[key]?.toIntOrNull() ?: default

        private fun Map<String, String>.float(key: String, default: Float): Float =
            this[key]?.toFloatOrNull() ?: default

        private fun Map<String, String>.bool(key: String, default: Boolean): Boolean =
            this[key]?.toBooleanStrictOrNull() ?: default
    }
}
